import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import { createTracker } from 'redux-segment';
import { pageMapper } from '../common/segment';
import rootReducer from '../reducers';

const enhancer = compose(
  applyMiddleware(thunk, createTracker(pageMapper)),
);

export default function configureStore(initialState, reducer = rootReducer) {
  const store = createStore(reducer, initialState, enhancer);
  return store;
}



// WEBPACK FOOTER //
// ./src/stores/index.prod.js